// 开发环境域名
//https://php-b2csaas.yixiangonline.com
const host_development = 'http://ser.xindongfenxiao.mz.xinzhidi.cn'//测试
const host_production = 'http://ser.xindongfenxiao.mz.xinzhidi.cn' //正式
export default {
	// 版本
	version: '2.5.5',
	baseURL: process.env.NODE_ENV == 'production' ? host_production : host_development,
	tencentMapKey: 'FWEBZ-WHSHV-IRFPO-UNMRL-5EUWV-BFBFW'
}